import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/system';

import { removeTheseProps } from '@/utils';

export type GridProps = Omit<BoxProps, 'display'> & {
  columns?: number;
  rows?: number;
  gap?: number;
};

export const Grid = styled(Box, {
  shouldForwardProp: removeTheseProps<GridProps>('columns', 'rows'),
})<GridProps>(({ columns = 3, rows = 0, gap = 3 }) => ({
  display: 'grid',
  gridTemplateColumns: columns ? `repeat(${columns}, 1fr)` : 'unset',
  gridTemplateRows: rows ? `repeat(${rows}, 1fr)` : 'unset',
  columnGap: gap,
  rowGap: gap,
}));
